import { ContentHeader, InfoCard, Progress } from "@backstage/core-components";
import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { SLOResponse } from "@internal/plugin-ops-review-common";
import { SLOCard } from "../SLOCard";
import { ExternalLink, Spacer } from "@internal/plugin-utilities";
import { SectionHeader } from "../TeamBreakdown/SectionHeader/SectionHeader";
import { InformationTooltip } from "../InformationTooltip";

export interface Props {
  companySloData: any;
  loading: boolean;
}

export const SLOSection: React.FC<Props> = ({
  companySloData,
  loading,
}): JSX.Element => {
  const tooltip = (
    <>
      <Typography variant="h5">Company SLOs</Typography>
      <div>
        This section displays the SLOs that are most associated with our overall
        company application health. This is based on a hard coded list of SLO
        ids. If you would like to add an SLO to the list please reach out to the
        IPA team.
      </div>
    </>
  );

  const header = (
    <div style={{ textAlign: "center" }}>
      <SectionHeader vendor="datadog" title="Company SLOs" />
      <ExternalLink href="https://app.datadoghq.com/dashboard/pub-cmd-c29/operations-overview?live=true" />
      <InformationTooltip
        title={tooltip}
        style={{ display: "inline", marginLeft: "10px" }}
      />
      <Spacer variant="normal" />
    </div>
  );

  if (loading) {
    return (
      <>
        {header}
        <Progress />
      </>
    );
  }

  let sloJSX = <Progress />;

  if (companySloData && companySloData["7d"]) {
    sloJSX = companySloData["7d"].map((_slo: SLOResponse, idx: number) => {
      const seven = companySloData["7d"][idx].data;
      const thirty = companySloData["30d"]?.[idx]?.data;

      return (
        <div key={idx}>
          <ContentHeader title={seven.slo.name} />
          <Spacer variant="normal" />
          <Grid container spacing={4}>
            <Grid item xs={6} key={7}>
              <SLOCard sloHistory={seven} days={7} key={seven.id} />
              <Spacer variant="normal" />
            </Grid>
            {thirty && (
              <Grid item xs={6} key={30}>
                <SLOCard sloHistory={thirty} days={30} key={thirty.id} />
              </Grid>
            )}
          </Grid>
          <Spacer variant="normal" />
        </div>
      );
    });
  }

  return (
    <>
      {header}
      <InfoCard>{sloJSX}</InfoCard>
    </>
  );
};
